<script setup>
    import Container from '../containers/Container.vue';
</script>

<template>
    <template v-if="loadingType == 'overlay'">
        <slot></slot>
        <div v-if="isLoading" class="flex-1 fixed z-50">
            <div class="flex items-center justify-center flex-col fixed top-0 left-0 w-full h-full z-10">
                <div class="absolute top-0 left-0 w-full h-full bg-grey-900 opacity-50"></div>
                <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="mt-4 text-white z-[2]">{{loadingText}}</div>
            </div>
        </div>
    </template>
    <template v-else>
        <Container v-if="isLoading">
            <div class="w-full flex items-center justify-center h-96 flex-col">
                <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="mt-4">Loading...</div>
            </div>
        </Container>
        <template v-else>
            <slot></slot>
        </template>
    </template>
</template>

<script>

    export default {
    data() {
        return {
            isLoading: this.isLoading,
            loadingType: this.type ? this.type : '',
            loadingText: this.loadText ? this.loadText : 'Loading...'
        }
    },
        props: ['isLoading', 'style', 'type', 'loadText']
    }

</script>


<style lang="scss" scoped>
  .lds-roller {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .lds-roller div {
        animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        transform-origin: 40px 40px;
    }
    .lds-roller div:after {
        content: " ";
        display: block;
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: theme('colors.orange-500');
        margin: -4px 0 0 -4px;
    }
    .lds-roller div:nth-child(1) {
        animation-delay: -0.036s;
    }
    .lds-roller div:nth-child(1):after {
        top: 63px;
        left: 63px;
    }
    .lds-roller div:nth-child(2) {
         animation-delay: -0.072s;
    }
    .lds-roller div:nth-child(2):after {
        top: 68px;
        left: 56px;
    }
    .lds-roller div:nth-child(3) {
        animation-delay: -0.108s;
    }
    .lds-roller div:nth-child(3):after {
        top: 71px;
        left: 48px;
    }
    .lds-roller div:nth-child(4) {
        animation-delay: -0.144s;
    }
    .lds-roller div:nth-child(4):after {
        top: 72px;
        left: 40px;
    }
    .lds-roller div:nth-child(5) {
        animation-delay: -0.18s;
    }
    .lds-roller div:nth-child(5):after {
        top: 71px;
        left: 32px;
    }
    .lds-roller div:nth-child(6) {
        animation-delay: -0.216s;
    }
    .lds-roller div:nth-child(6):after {
        top: 68px;
        left: 24px;
    }
    .lds-roller div:nth-child(7) {
        animation-delay: -0.252s;
    }
    .lds-roller div:nth-child(7):after {
        top: 63px;
        left: 17px;
    }
    .lds-roller div:nth-child(8) {
        animation-delay: -0.288s;
    }
    .lds-roller div:nth-child(8):after {
        top: 56px;
        left: 12px;
    }
    @keyframes lds-roller {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

</style>